import type { Locale } from "../locale.ts";

export const WIDTHS = {
  menu: [337],
  card: [594, 472, 684, 298],
  wide: [1252, 1008],
  hero: [1272, 1152, 318],
} as const;

export const HEIGHTS: Readonly<Partial<Record<Locale, Readonly<Record<string, number>>>>> = {
  en: {
    "apps.298": 471,
    "apps.472": 480,
    "apps.594": 449,
    "apps.684": 516,
    "audience.298": 246,
    "audience.472": 246,
    "audience.594": 303,
    "audience.684": 348,
    "backfill.298": 226,
    "backfill.472": 289,
    "backfill.594": 289,
    "backfill.684": 289,
    "boosts.298": 358,
    "boosts.472": 436,
    "boosts.594": 328,
    "boosts.684": 328,
    "charts.298": 278,
    "charts.472": 278,
    "charts.594": 303,
    "charts.684": 348,
    "climb.298": 328,
    "climb.472": 328,
    "climb.594": 328,
    "climb.684": 328,
    "earning.298": 333,
    "earning.472": 328,
    "earning.594": 292,
    "earning.684": 256,
    "editor.1008": 433,
    "editor.1252": 456,
    "editor.298": 266,
    "editor.684": 362,
    "experiments.298": 200,
    "experiments.472": 180,
    "experiments.594": 180,
    "experiments.684": 180,
    "findings.298": 549,
    "findings.472": 480,
    "findings.594": 468,
    "findings.684": 535,
    "giveaway-impact.298": 280,
    "giveaway-impact.472": 441,
    "giveaway-impact.594": 468,
    "giveaway-impact.684": 490,
    "giveaway.298": 244,
    "giveaway.472": 372,
    "giveaway.594": 372,
    "giveaway.684": 372,
    "growth.298": 247,
    "growth.472": 247,
    "growth.594": 303,
    "growth.684": 348,
    "hero-growth.1152": 1126,
    "hero-growth.1272": 601,
    "hero-growth.318": 698,
    "hero-levels.1152": 1126,
    "hero-levels.1272": 601,
    "hero-levels.318": 698,
    "hero-overview.1152": 1126,
    "hero-overview.1272": 601,
    "hero-overview.318": 698,
    "hero-team.1152": 1126,
    "hero-team.1272": 601,
    "hero-team.318": 228,
    "history.298": 246,
    "history.472": 246,
    "history.594": 303,
    "history.684": 348,
    "impact.298": 335,
    "impact.472": 480,
    "impact.594": 468,
    "impact.684": 535,
    "import.298": 202,
    "import.472": 214,
    "import.594": 244,
    "import.684": 244,
    "ladder.298": 323,
    "ladder.337": 366,
    "ladder.472": 460,
    "ladder.594": 460,
    "ladder.684": 460,
    "level-up.298": 205,
    "level-up.472": 271,
    "level-up.594": 295,
    "level-up.684": 295,
    "members.298": 203,
    "members.337": 229,
    "members.472": 246,
    "members.594": 158,
    "members.684": 180,
    "own-bot.298": 272,
    "own-bot.472": 335,
    "own-bot.594": 352,
    "own-bot.684": 340,
    "perks.298": 370,
    "perks.472": 480,
    "perks.594": 468,
    "perks.684": 445,
    "privacy.298": 265,
    "privacy.472": 347,
    "privacy.594": 289,
    "privacy.684": 289,
    "pulse.298": 549,
    "pulse.472": 480,
    "pulse.594": 468,
    "pulse.684": 535,
    "rank.298": 200,
    "rank.472": 265,
    "rank.594": 289,
    "rank.684": 289,
    "requests.298": 240,
    "requests.472": 323,
    "requests.594": 283,
    "requests.684": 323,
    "roster.298": 214,
    "roster.337": 218,
    "roster.472": 218,
    "roster.594": 218,
    "roster.684": 218,
    "rules.298": 549,
    "rules.472": 480,
    "rules.594": 468,
    "rules.684": 518,
    "team.1008": 248,
    "team.1252": 248,
    "team.298": 191,
    "team.684": 242,
  },
  ru: {
    "apps.298": 471,
    "apps.472": 480,
    "apps.594": 449,
    "apps.684": 516,
    "audience.298": 246,
    "audience.472": 246,
    "audience.594": 303,
    "audience.684": 348,
    "backfill.298": 226,
    "backfill.472": 289,
    "backfill.594": 289,
    "backfill.684": 289,
    "boosts.298": 358,
    "boosts.472": 432,
    "boosts.594": 328,
    "boosts.684": 328,
    "charts.298": 278,
    "charts.472": 278,
    "charts.594": 303,
    "charts.684": 348,
    "climb.298": 328,
    "climb.472": 328,
    "climb.594": 328,
    "climb.684": 328,
    "earning.298": 361,
    "earning.472": 364,
    "earning.594": 328,
    "earning.684": 292,
    "editor.1008": 433,
    "editor.1252": 456,
    "editor.298": 266,
    "editor.684": 362,
    "experiments.298": 200,
    "experiments.472": 180,
    "experiments.594": 180,
    "experiments.684": 180,
    "findings.298": 549,
    "findings.472": 480,
    "findings.594": 468,
    "findings.684": 535,
    "giveaway-impact.298": 280,
    "giveaway-impact.472": 441,
    "giveaway-impact.594": 468,
    "giveaway-impact.684": 490,
    "giveaway.298": 258,
    "giveaway.472": 394,
    "giveaway.594": 394,
    "giveaway.684": 372,
    "growth.298": 247,
    "growth.472": 247,
    "growth.594": 303,
    "growth.684": 348,
    "hero-growth.1152": 1126,
    "hero-growth.1272": 601,
    "hero-growth.318": 698,
    "hero-levels.1152": 1126,
    "hero-levels.1272": 601,
    "hero-levels.318": 698,
    "hero-overview.1152": 1126,
    "hero-overview.1272": 601,
    "hero-overview.318": 698,
    "hero-team.1152": 1126,
    "hero-team.1272": 601,
    "hero-team.318": 228,
    "history.298": 246,
    "history.472": 246,
    "history.594": 303,
    "history.684": 348,
    "impact.298": 335,
    "impact.472": 480,
    "impact.594": 468,
    "impact.684": 535,
    "import.298": 202,
    "import.472": 214,
    "import.594": 244,
    "import.684": 244,
    "ladder.298": 323,
    "ladder.337": 366,
    "ladder.472": 460,
    "ladder.594": 460,
    "ladder.684": 460,
    "level-up.298": 220,
    "level-up.472": 271,
    "level-up.594": 295,
    "level-up.684": 295,
    "members.298": 203,
    "members.337": 229,
    "members.472": 246,
    "members.594": 158,
    "members.684": 180,
    "own-bot.298": 272,
    "own-bot.472": 346,
    "own-bot.594": 384,
    "own-bot.684": 352,
    "perks.298": 370,
    "perks.472": 480,
    "perks.594": 468,
    "perks.684": 481,
    "privacy.298": 265,
    "privacy.472": 347,
    "privacy.594": 289,
    "privacy.684": 289,
    "pulse.298": 549,
    "pulse.472": 480,
    "pulse.594": 468,
    "pulse.684": 535,
    "rank.298": 216,
    "rank.472": 265,
    "rank.594": 289,
    "rank.684": 289,
    "requests.298": 240,
    "requests.472": 323,
    "requests.594": 283,
    "requests.684": 323,
    "roster.298": 214,
    "roster.337": 218,
    "roster.472": 218,
    "roster.594": 218,
    "roster.684": 218,
    "rules.298": 549,
    "rules.472": 480,
    "rules.594": 468,
    "rules.684": 535,
    "team.1008": 248,
    "team.1252": 248,
    "team.298": 191,
    "team.684": 242,
  },
};
